// Giới hạn ảnh/video áp dụng PER-ĐƠN (mỗi dòng). Dùng chung cho cả luồng chụp/quay
// (camera in-app) lẫn luồng chọn file từ máy, để validate nhất quán ở một chỗ.

export const MAX_IMAGES = 20
export const MAX_VIDEOS = 10
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024
export const MAX_VIDEO_SIZE = 500 * 1024 * 1024

export const isImage = (mimetype) => typeof mimetype === 'string' && mimetype.indexOf('image/') === 0
export const isVideo = (mimetype) => typeof mimetype === 'string' && mimetype.indexOf('video/') === 0

// ---- Định dạng mã đơn (barcode) ----
// Quy tắc nghiệp vụ DÙNG CHUNG cho mọi luồng (quét camera, đọc từ ảnh, nhập tay): vd 123456_1
// hoặc #123456_1. Đặt một chỗ để format không bị lệch giữa các nơi nhập.
export const BARCODE_RE = /^#?\d+_\d+$/

// Chuẩn hóa mã đơn: bỏ khoảng trắng + dấu '#' đầu (để so trùng và gọi API theo NGUYÊN mã item).
export const normalizeBarcode = (v) => (v || '').trim().replace(/^#/, '')

// SỐ ĐƠN (order) = mã item bỏ hậu tố _1, _2, ... (và dấu '#'). Ví dụ '10024693_1' -> '10024693'.
// Mỗi dòng ứng với 1 ĐƠN, không phải 1 item barcode: các item cùng đơn (_1, _2...) coi như một.
// Dùng để so trùng giữa các dòng và gom nhiều QR trong 1 ảnh về cùng 1 đơn.
// LƯU Ý: gọi API vẫn dùng normalizeBarcode (nguyên mã item, vd 10024693_1), CHỈ định danh/hiển thị
// mới dùng orderNumberOf.
export const orderNumberOf = (v) => normalizeBarcode(v).replace(/_\d+$/, '')

// ---- Trạng thái yêu cầu chụp ảnh của đơn ----
// Chỉ cho chụp/upload khi đơn ở trạng thái "photo_requested".
export const PHOTO_REQUESTED = 'photo_requested'
// Đã tải ảnh lên (photo_updated) / đã duyệt (photo_confirmed) — trạng thái HOÀN TẤT: không cần
// tải thêm. Đây là kết quả BÌNH THƯỜNG sau khi lưu, KHÔNG phải lỗi (dùng để hiển thị thông báo
// tích cực thay vì cảnh báo "không thể tải ảnh").
export const PHOTO_UPDATED = 'photo_updated'
export const PHOTO_CONFIRMED = 'photo_confirmed'

// Lấy trạng thái photo của đơn. Ưu tiên field request_photo_status (BE trả thẳng);
// nếu không có thì suy từ tags (photo status nằm trong barcode.tags theo dữ liệu hệ thống).
export const getPhotoStatus = (orderData) => {
    if (!orderData) return null
    const direct = orderData.request_photo_status
        || (orderData._origin_request && orderData._origin_request.request_photo_status)
    if (direct) return direct
    const tagSources = [
        orderData.barcode && orderData.barcode.tags,
        orderData.tags,
        orderData.order3D && orderData.order3D.tags,
        orderData.product && orderData.product.tags,
        orderData._origin_request && orderData._origin_request.tags,
    ]
    const tags = tagSources.filter(Boolean).reduce((acc, t) => acc.concat(t), [])
    const found = tags.find(t => ['photo_requested', 'photo_updated', 'photo_confirmed'].indexOf(t) !== -1)
    return found || null
}

// Đơn có đang ở trạng thái cần chụp ảnh không (cho phép chụp/upload).
// FAIL-CLOSED: KHÔNG đọc được trạng thái → KHÔNG cho phép chụp/upload (theo nghiệp vụ: chỉ đơn
// xác định rõ photo_requested mới được tải ảnh; không xác định được thì chặn cho an toàn).
export const isPhotoRequested = (orderData) => getPhotoStatus(orderData) === PHOTO_REQUESTED

// Đơn đã có ảnh (đã tải lên / đã duyệt) → trạng thái hoàn tất, không cho tải thêm nhưng KHÔNG
// coi là lỗi. Phân biệt với các trạng thái "không hợp lệ khác" để hiển thị thông báo phù hợp.
export const isPhotoDone = (orderData) => {
    const s = getPhotoStatus(orderData)
    return s === PHOTO_UPDATED || s === PHOTO_CONFIRMED
}

// Đếm số ảnh/video hiện có của 1 dòng (ảnh đã lưu trên server + ảnh/video đang chờ).
export const countRowMedia = (existingPhotos, pendingFiles) => ({
    images: existingPhotos.filter(p => isImage(p.mimetype)).length
        + pendingFiles.filter(f => isImage(f.file.type)).length,
    videos: existingPhotos.filter(p => isVideo(p.mimetype)).length
        + pendingFiles.filter(f => isVideo(f.file.type)).length,
})
